/**
 * VERSIONE LIBRERIA 3
 */

var ViewList = ViewCollection.extend({
    visibleKeys: [],
    keys: [],
    init: function (modelName, data, config) {
        this._super(modelName, data, config);
        this.type = 'list';
        this.defaultRenderType = 'text';
        //this.defaultRenderClassName = 'text';
        this.routeType = 'list';
    },

    getModelData: function (index) {
        throw 'ViewList.getModelData not implemented';
    }
});

var ViewEdit = ViewRecord.extend({
    visibleKeys: [],
    keys: [],
    isHasMany: false,
    hasManyIndex : null, // indice view hasmany da inserire nella creazione dei nomi dei campi
    init: function (modelName, config, data) {

        this._super(modelName, config, data);
        this.visibleKeys = [];
        this.keys = [];
        this.type = 'edit';
        this.renderObjs[0] = {};
        this.defaultRenderType = 'input';
        //this.defaultRenderClassName = 'input';
        this.routeType = 'edit';
    },

    _getFieldName: function (key) {
        var self = this;
        console.log('ViewEdit._getFieldName',self.isHasMany);
        if (self.isHasMany) {
            var name = Utility.camelCase(self.modelName) + '-' + key;
            name += self.hasManyIndex === null ? '[]' : '[' + self.hasManyIndex + ']';
            return name;
        }
        return key;
    },

    _render: function () {

        var self = this;

        self._super();

            if (self.isHasMany) {
                var buttons = $.getTemplate('#default_hasmany_item_buttons_tpl', {});
                // tmpContainer.append(buttons);

                $(self.config.container).find('[data-edit-main]').append(buttons);
                //console.log("CONTAINER: ", $(self.config.container).find('[data-edit-main]'));
                //console.log("HTML: ", $(self.config.container).html());
            }
    }
});

var ViewEditG2 = ViewEdit.extend({
    _renderElement: function (key) {
        var self = this;
        if (self.isHasMany) {
            //log.debug("RENDERIZZO KEY ",key);
        }
        // caso speciale per gli hidden che non hanno struttura html
        var type = self.config.fields_type[key] ? self.config.fields_type[key].type : 'input';
        var container = null;
        if (type == 'input' && self.config.fields_type[key] && self.config.fields_type[key].inputType=="hidden") {
            container = $.createDynamicContainer();
            var r = self._createRender(container, key);
            r.render();
            self.jQe.find('[data-hidden_fields]').append(container.html());
            r.container = self.jQe.find('[data-hidden_fields]');
            container.remove();
            return;
        }
        var structure = self._getDefaultStructure(key); //self.config.labels?self.config.labels:'left';
        container = $.createDynamicContainer('#' + self.prefixTemplateClass + '_' + structure + '_view_edit_tpl');
        var safeKey = key.replace(/[\])}\[{(]/g, '');
        container.find('.' + type + '-field').addClass('field-' + safeKey + ' ' + self.modelName + '-field-' + safeKey);
        $(container.first().children()[0]).addClass('view-field-'+safeKey);

        self._translateItem(container, safeKey);
        if (self.langs.length > 1) {
            var imgLang = self._langField(self.config, key);
            self._renderImgLang(container, imgLang);
        }
        container.find('[data-field_value]').attr('data-field_value', key);
        var group = self._getGroup(key);
        self.jQe.find('[data-view_elements="' + self.modelName + '"]')
            .find('[data-group="' + group + '"]')
            .append(container.html());
        //self.jQe.find('[data-view_elements="' + self.modelName + '"]').append(container.html());
        container.remove();
        var realContainer = self.jQe.find('[data-view_elements="' + self.modelName + '"]').find('[data-field_value="' + key + '"]');

        var r = self._createRender(realContainer, key);
        r.render();
    },
    _getGroup: function (key) {
        var self = this;
        var group = 'g0';
        for (var g in self.config.groups) {
            if ($.inArray(key, self.config.groups[g].fields) >= 0) {
                return g;
            }
        }
        return group;
    }
});

var ViewEditG3 = ViewEditG2.extend({});

var ViewEditG4 = ViewEditG3.extend({});

var ViewEditG5 = ViewEditG4.extend({});

var ViewWizard = ViewEdit.extend({
    _currentWizard : 0,
    _render : function () {
        var self = this;
        self._currentWizard = 0;
        var section = $(self.jQe).find('[data-wizard]')[0].outerHTML;
        var keys = _.union([],self.config.wizard[0].fields);
        for (var i=1;i<self.config.wizard.length;i++) {
            //$(self.jQe).find('[data-wizard]').attr('data-wizard',i);
            //$(self.jQe).find('[data-wizard]').clone();


            section  = $(section).attr('data-wizard',i)[0].outerHTML;
            //console.log('section',$(section).html());
            $(self.jQe).find('[data-view_elements]').append(section);
            keys = _.union(keys,self.config.wizard[i].fields);
        }
        self.config.fields = keys;
        self._super();
    },

    _finalize : function () {
        var self = this;
        $(self.config.container).find('[data-button_back]').click(function () {
            self._back();
        })
        $(self.config.container).find('[data-button_forward]').click(function () {
            self._forward();
        })
        self._switchWizard(0,0);
        //$(self.config.container).find('[data-wizard_title]').html(self.config.wizard[0].title);
        self._super();
    },

    _back : function () {
        var self = this;
        if (self._currentWizard == 0)
            return ;
        self._currentWizard--;
        self._switchWizard(self._currentWizard+1,self._currentWizard);
    },

    _forward : function () {
        var self = this;
        if (self._currentWizard >= self.config.wizard.length-1) {
            $(self.config.container).find('[data-alert]').addClass('hide').html('');
            // salvataggio
            self._save();
            return;
        }
        self._currentWizard++;
        self._switchWizard(self._currentWizard-1,self._currentWizard);
    },
    _save : function () {
        var self = this;
        if (self.config.extra_actions && self.config.extra_actions.actionSave) {
            if (_.isFunction(self.config.extra_actions.actionSave.func) ) {
                self.config.extra_actions.actionSave.view = self;
                self.config.extra_actions.actionSave.func();
                return ;
            }
            
        }
        self._controller.actionSave(self.keyId,self.pk,{},function (json) {
            if (json.error) {
                $(self.config.container).find('[data-alert]').removeClass('hide').html(json.msg);
            }
        });
    },
    _switchWizard : function(hide,show) {
        var self = this;
        $(self.config.container).find('[data-wizard_title]').html(self.config.wizard[show].title);
        $(self.config.container).find('[data-wizard="' + hide + '"]').addClass('hide');
        $(self.config.container).find('[data-wizard="' + show + '"]').removeClass('hide');
        if (self._currentWizard == self.config.wizard.length-1) {
            $(self.config.container).find('[data-button_forward]').html('Salva');
        } else {
            $(self.config.container).find('[data-button_forward]').html('Avanti');
        }
        if (self._currentWizard == 0) {
            $(self.config.container).find('[data-button_back]').addClass('disabled').attr('disabled','disabled')
        } else {
            $(self.config.container).find('[data-button_back]').removeClass('disabled').removeAttr('disabled');
        }
    },
    _renderElement: function (key) {
        var self = this;
        // caso speciale per gli hidden che non hanno struttura html
        var type = self.config.fields_type[key] ? self.config.fields_type[key].type : 'input';
        var container = null;
        if (type == 'input' && self.config.fields_type[key] && self.config.fields_type[key].inputType=="hidden") {
            container = $.createDynamicContainer();
            var r = self._createRender(container, key);
            r.render();
            self.jQe.find('[data-hidden_fields]').append(container.html());
            r.container = self.jQe.find('[data-hidden_fields]');
            container.remove();
            return;
        }

        var structure = self._getDefaultStructure(key); //self.config.labels?self.config.labels:'left';
        container = $.createDynamicContainer('#' + self.prefixTemplateClass + '_' + structure + '_view_edit_tpl');
        var safeKey = key.replace(/[\])}\[{(]/g, '');

        container.find('.' + type + '-field').addClass('field-' + safeKey + ' ' + self.modelName + '-field-' + safeKey);
        $(container.first().children()[0]).addClass('view-field-'+safeKey);
        self._translateItem(container, safeKey);
        if (self.langs.length > 1) {
            var imgLang = self._langField(self.config, key);
            self._renderImgLang(container, imgLang);
        }
        container.find('[data-field_value]').attr('data-field_value', key);
        var wizard = self._getWizard(key);
        console.log('section wizard',key,wizard);
        self.jQe.find('[data-view_elements="' + self.modelName + '"]')
            .find('[data-wizard="' + wizard + '"]')
            .append(container.html());
        //self.jQe.find('[data-view_elements="' + self.modelName + '"]').append(container.html());
        container.remove();
        var realContainer = self.jQe.find('[data-view_elements="' + self.modelName + '"]').find('[data-field_value="' + key + '"]');

        var r = self._createRender(realContainer, key);
        r.render();
    },
    _getWizard: function (key) {
        var self = this;
        var wizard = '0';

        for (var w in self.config.wizard) {
            if ($.inArray(key, self.config.wizard[w].fields) >= 0) {
                return w;
            }
        }
        return wizard;
    },
    _getTemplate : function () {
        var self = this;
        var tplId = self.config.templateId;
        if (!tplId) {
            self.config.templateId = '#'+ self.prefixTemplateClass +'_view_'+self.type+'_wizard_tpl';
            tplId = self.config.templateId;
        }
        return $.createDynamicContainer(tplId);

        //return $.createDynamicContainer(tplId);
    },
})


var ViewSearch = ViewRecord.extend({
    init: function (modelName, data, config) {
        this._super(modelName, data, config);
        this.type = 'search';
        this.defaultRenderType = 'input';
        //this.defaultRenderClassName = 'input';
        this.renderObjs[0] = {};
        this.routeType = 'search';
    },
    getParams: function () {
        var self = this;
        var form = $(self.config.container).find('form');
        if (form.length === 0)
            throw 'impossibile trovare il form search in ' + self.config.container;
        return form.serializeAssoc();
    },
    _renderElement: function (key) {
        var self = this;
        if (self.isHasMany) {
            //log.debug("RENDERIZZO KEY ",key);
        }
        // caso speciale per gli hidden che non hanno struttura html
        var type = self.config.fields_type[key] ? self.config.fields_type[key].type : 'input';
        var container = '';
        if (type == 'input' && self.config.fields_type[key] && self.config.fields_type[key].inputType=="hidden") {

            container = $.createDynamicContainer();
            var r = self._createRender(container, key);
            r.render();
            self.jQe.find('[data-hidden_fields]').append(container.html());
            r.container = self.jQe.find('[data-hidden_fields]');
            container.remove();
            return;
        }


        var structure = self._getDefaultStructure(key); //self.config.labels?self.config.labels:'left';
        container = $.createDynamicContainer('#' + self.prefixTemplateClass + '_' + structure + '_view_edit_tpl');
        var safeKey = key.replace(/[\])}\[{(]/g, '');
        container.find('.' + type + '-field').addClass('field-' + safeKey + ' ' + self.modelName + '-field-' + safeKey);
        $(container.first().children()[0]).addClass('view-field-'+safeKey);
        self._translateItem(container, safeKey);
        if (self.langs.length > 1) {
            var imgLang = self._langField(self.config, key);
            self._renderImgLang(container, imgLang);
        }
        container.find('[data-field_value]').attr('data-field_value', key);
        //console.log(container.html());

        self.jQe.find('[data-view_elements="' + self.modelName + '"]').append(container.html());
        container.remove();
        var realContainer = self.jQe.find('[data-view_elements="' + self.modelName + '"]').find('[data-field_value="' + key + '"]');
        var r = self._createRender(realContainer, key);
        r.render();
    },
    _render: function () {
        var self = this;
        self._super();
        if (self.keys.length === 0) {
            $(self.config.container).remove();
        }

    }
});

var ViewSearchG2 = ViewSearch.extend({
    getParams: function () {
        var self = this;
        var form = $(self.config.container).find('form');
        if (form.length === 0)
            throw 'impossibile trovare il form search in ' + self.config.container;
        return form.serializeAssoc();
    },
    _renderElement: function (key) {
        var self = this;

        // caso speciale per gli hidden che non hanno struttura html
        var type = self.config.fields_type[key] ? self.config.fields_type[key].type : 'input';
        if (type == 'input' && self.config.fields_type[key] && self.config.fields_type[key].inputType=="hidden") {
            console.log('SEARCH HIDDENT');
            var container = $.createDynamicContainer();
            var r = self._createRender(container, key);
            r.render();
            self.jQe.find('[data-hidden_fields]').append(container.html());
            r.container = self.jQe.find('[data-hidden_fields]');
            container.remove();
            return;
        }

        var structure = self._getDefaultStructure(key); //self.config.labels?self.config.labels:'left';
        console.log('SEARCH STRUCT', structure);
        var container = $.createDynamicContainer('#' + self.prefixTemplateClass + '_' + structure + '_view_edit_tpl');
        var safeKey = key.replace(/[\])}\[{(]/g, '');
        container.find('.' + type + '-field').addClass('field-' + safeKey + ' ' + self.modelName + '-field-' + safeKey);
        $(container.first().children()[0]).addClass('view-field-'+safeKey);
        self._translateItem(container, safeKey);
        if (self.langs.length > 1) {
            var imgLang = self._langField(self.config, key);
            self._renderImgLang(container, imgLang);
        }
        container.find('[data-field_value]').attr('data-field_value', key);
        //console.log(container.html());
        var group = self._getGroup(key);
        self.jQe.find('[data-view_elements="' + self.modelName + '"]').find('[data-group="' + group + '"]').append(container.html());
        //self.jQe.find('[data-view_elements="' + self.modelName + '"]').append(container.html());
        container.remove();
        var realContainer = self.jQe.find('[data-view_elements="' + self.modelName + '"]').find('[data-field_value="' + key + '"]');


        var r = self._createRender(realContainer, key);
        r.render();
    },
    _getGroup: function (key) {
        var self = this;
        var group = 'g0';
        for (var g in self.config.groups) {
            if ($.inArray(key, self.config.groups[g].fields) >= 0)
                return g;
        }
        return group;
    }
});

var ViewSearchAdvancedG2 = ViewSearchG2.extend({

    _getTemplate : function () {
        var self = this;
        var tplId = self.config.templateId;
        if (!tplId) {
            tplId = '#'+ self.prefixTemplateClass +'_view_'+self.type+'_advanced_group2_tpl';
            self.config.templateId = tplId;
        }
        console.log(tplId);
        return $.createDynamicContainer(tplId);
    },

});


var ViewView = ViewEdit.extend({
    init: function (modelName, data, config) {
        this._super(modelName, data, config);
        this.type = 'view';
        //this.renderObjs[0] = {};
        this.defaultRenderType = 'text';
        //this.defaultRenderClassName = 'text';
        this.routeType = 'view';
    },
});
var ViewViewG2 = ViewEditG2.extend({
    init: function (modelName, data, config) {
        this._super(modelName, data, config);
        this.type = 'view';
        //this.renderObjs[0] = {};
        this.defaultRenderType = 'text';
        //this.defaultRenderClassName = 'text'
        this.routeType = 'view';
    },
});

var ViewViewG3 = ViewEditG3.extend({
    init: function (modelName, data, config) {
        this._super(modelName, data, config);
        this.type = 'view';
        //this.renderObjs[0] = {};
        this.defaultRenderType = 'text';
        //this.defaultRenderClassName = 'text';
        this.routeType = 'view';
    },
});

var ViewCalendar = ViewCollection.extend({
    calendarContainer: null,
    init: function (modelName, data, config) {
        this._super(modelName, data, config);
        this.type = 'calendar';
        this.defaultRenderType = 'text';
        this.routeType = 'calendar';
    },

    _render: function () {
        var self = this;
        var jQe = self.jQe;
        console.log($(jQe).find('[data-calendar]').length);
        var options = {
            dayClick: function (date, jsEvent, view) {
                //alert('a day has been clicked!');
                // if (self.config.dayClick) {
                //     return self.config.dayClick(date, jsEvent, view);
                // }
                self.dayClick(date, jsEvent, view);
            },
            eventClick: function (calEvent, jsEvent, view) {
                // if (self.config.eventClick) {
                //     return self.config.eventClick(calEvent, jsEvent, view);
                // }
                self.eventClick(calEvent, jsEvent, view);
            },
            viewRender: function (view, element) {
                self.startDate = view.start.toDate();
                self.endDate = view.end.toDate();
                // if (self.config.viewRender) {
                //     self.config.viewRender(view, element);
                //     return;
                // }
                log.debug('VIEW RENDERE ' + view.start.toDate() + view.end.toDate());
                self.loadEvents();
            },
            eventAfterAllRender: function (view) {
                //console.log("DDDDD");
                if (self.count == 1)
                    return;
                self.count = 1;
                log.debug('VIEW AFTER   RENDERE ' + view.start.toDate() + view.end.toDate());

            }
        };
        options = _.extend(options,self.config.options);
        var dayClick = options['dayClick'];
        options['dayClick'] = function () {
            dayClick.apply(self, _.values(arguments));
        }

        var eventClick = options['eventClick'];
        options['eventClick'] = function () {
            eventClick.apply(self, _.values(arguments));
        }

        var viewRender = options['viewRender'];
        options['viewRender'] = function () {
            viewRender.apply(self, _.values(arguments));
        }

        var eventAfterAllRender = options['eventAfterAllRender'];
        options['eventAfterAllRender'] = function () {
            eventAfterAllRender.apply(self, _.values(arguments));
        }
        //Cambio il caller da calendar a view

        // for (var f in options) {
        //         console.log("CALENDARFUNC: ",f, options[f]);
        //     if (_.isFunction(options[f])) {
        //         console.log("CALENDARFUNC2: ",f);
        //         var func = options[f];
        //         options[f] = function () {
        //             func.apply(self, _.values(arguments));
        //         }
        //     }
        // }

        // options['viewRender'] = function (date, jsEvent, view) {
        //     viewRender.apply(self, _.values(this.arguments));
        // }

        console.log('OPSTION',options);
        $(jQe).find('[data-calendar]').fullCalendar(options);
        self.calendarContainer = $(jQe).find('[data-calendar]');


    },

    loadEvents: function () {
        var self = this;
        var jQe = self.jQe;
        $(jQe).find('[data-calendar]').fullCalendar('removeEvents');
        var events = [];
        //console.log(self.data.value);
        for (var i in self.data.value) {
            var value = self.data.value[i];
            //log.debug('calendar event value',value);
            var backgroundColor = 'green';
            var textColor = 'white';
            var title = 'notitle';
            if (self.config.backgroundColor) {

                var params = {};
                var args = self.config.backgroundColor.toString().match(/function\s*\w*\s*\((.*?)\)/)[1].split(/\s*,\s*/);
                for (var a in args)
                    params[args[a]] = value[args[a]];
                backgroundColor = self.config.backgroundColor.apply(self, _.values(params));
            }
            if (self.config.textColor) {
                var params = {};
                var args = self.config.textColor.toString().match(/function\s*\w*\s*\((.*?)\)/)[1].split(/\s*,\s*/);
                for (var a in args)
                    params[args[a]] = value[args[a]];
                textColor = self.config.textColor.apply(self, _.values(params));
            }
            if (_.isFunction(self.config.title) ) {
                var params = {};
                var args = self.config.title.toString().match(/function\s*\w*\s*\((.*?)\)/)[1].split(/\s*,\s*/);
                for (var a in args)
                    params[args[a]] = value[args[a]];
                title = self.config.title.apply(self, _.values(params));
            } else {
                title = value[self.config.title];
            }
            //if (!parseInt(model.data.attivo))
            //  bgcolor = 'red';
            if (!value[self.config.data_inizio]) {
                log.warn('data evento non valida. Scartato:', value);
                continue;

            }
            var ev = {
                id: value[self.config.id] ? model.data[self.config.id] : value.id,
                title: title,
                start: value[self.config.data_inizio],
                end: value[self.config.data_fine] ? value[self.config.data_fine] : null,
                backgroundColor: backgroundColor,
                textColor: textColor
            };
            //log.info(value,'evento ',ev);
            events.push(ev);

        }
        log.info('aggiunti eventi ', events);
        $(jQe).find('[data-calendar]').fullCalendar('addEventSource', events);
    },

    dayClick: function (date, jsEvent, view) {

    },
    eventClick: function (calEvent, jsEvent, view) {

    },

    renderOld: function (options) {
        var self = this;
        self.options = options;
        self._setKeys();
        //console.log(self.model);
        $(options.calendar).fullCalendar('removeEvents');
        var events = [];
        if (self.model.length > 0) {
            for (var m in self.model) {
                var model = self.model[m];
                backgroundColor = 'green';
                textColor = 'white';
                if (self.modelConfs.backgroundColor) {
                    var params = {};
                    var args = self.modelConfs.backgroundColor.toString().match(/function\s*\w*\s*\((.*?)\)/)[1].split(/\s*,\s*/);
                    for (var a in args)
                        params[args[a]] = model.data[args[a]];
                    backgroundColor = self.modelConfs.backgroundColor.apply(self._controller, _.values(params));
                }

                if (self.modelConfs.textColor) {
                    var params = {};
                    var args = self.modelConfs.textColor.toString().match(/function\s*\w*\s*\((.*?)\)/)[1].split(/\s*,\s*/);
                    for (var a in args)
                        params[args[a]] = model.data[args[a]];
                    textColor = self.modelConfs.textColor.apply(self._controller, _.values(params));
                }

                //if (!parseInt(model.data.attivo))
                //  bgcolor = 'red'; 
                var ev = {
                    id: model.data[self.modelConfs.id] ? model.data[self.modelConfs.id] : model.data.id,
                    title: model.data[self.modelConfs.title],
                    start: model.data[self.modelConfs.data_inizio],
                    end: model.data[self.modelConfs.data_fine] ? model.data[self.modelConfs.data_fine] : null,
                    backgroundColor: backgroundColor,
                    textColor: textColor
                };
                console.log("evento ", ev);
                events.push(ev);

            }
            log.info(events);
            $(options.calendar).fullCalendar('addEventSource', events);
        }
    }
});

var ViewCsvTreFasi = ViewRecord.extend({
    fileName: null,
    fileOriginalName: null,
    loadId: null,
    phases: ['upload', 'load', 'save'],
    currentPhase: 'upload',
    uploadForm: null,
    extraValues: {},   // valori degli extraValues field

    uploadPhase: 0,
    loadPhase: 1,
    savePhase: 2,

    init: function (modelName, config, data) {
        this._super(modelName, config, data);
        this.type = 'csv';
        this.renderObjs[0] = {};
        this.defaultRenderType = 'input';
        this.routeType = 'csv';
    },

    setPhase: function (phase) {
        var self = this;
        self.currentPhase = phase;
        self._getExtraFields();
    },

    goToNextPhase: function () {
        var self = this;
        var phase = self.currentPhase;
        switch (phase) {
            case 'upload':
                return self.setPhase('load');
            case 'load':
                return self.setPhase('save');
            case 'save':
                return self.setPhase('upload');

            default:
                //phase = phase + 1;
                return;
        }
    },

    showProgress: function (msg, progress) {
        var self = this;
        var prg = $(self.config.container).find('[data-csvstatus]');
        if (progress === false || progress === undefined) {
            $(prg).find(".progress").css("width", "100%");
            $(prg).find(".progress-bar").text(" ");
        } else {
            $(prg).find(".progress").css("width", progress + "%");
            $(prg).find(".progress-bar").text(progress + "%");
        }
        $(prg).find('[data-csvstatus_msg]').html(msg);
        $(prg).removeClass('hide');
    },
    hideProgress: function () {
        var self = this;
        $(self.config.container).find('[data-csvstatus]').addClass('hide');
    },
    _setKeys: function () {
        var self = this;
        var currentKeys = {}
        switch (self.currentPhase) {
            case self.phases[self.uploadPhase]:
                currentKeys = {};
                break;
            case self.phases[self.loadPhase]:
                currentKeys = self.config.load_fields ? self.config.load_fields : [];
                break;
            case self.phases[self.savePhase]:

                currentKeys = self.config.save_fields ? self.config.save_fields : [];
                break;
        }
        self.keys = Object.keys(currentKeys);
    },
    setLoadId: function (jobId) {
        var self = this;
        self.loadId = jobId;
        self.dataForm.find('input[name="csv_load_id"]').val(jobId).attr('value', jobId);
    },
    _finalize: function () {
        var self = this;
        self._initUploadForm();
    },

    _renderActions: function () {
        var self = this;
        switch (self.currentPhase) {
            case self.phases[self.uploadPhase]:
                self.config.actions = self.config.upload_actions;
                break;
            case self.phases[self.loadPhase]:
                $(self.config.container).find('form[name="upload_form"]').addClass('hide');
                $(self.config.container).find('[data-filename]').html(self.fileOriginalName);
                self.config.actions = self.config.load_actions;
                break;
            case self.phases[self.savePhase]:
                $(self.config.container).find('form[name="upload_form"]').addClass('hide');
                self.config.actions = self.config.save_actions;
                break;
        }
        console.log("csvview actions", self.config.actions);
        self._super();
        //self._controller.connectActions(self.keyId);
    },

    _render: function () {
        var self = this;
        self._super();
        self._setFormData();
        self._setExtraFields();
    },

    _getExtraFields: function () {
        var self = this;
        var data = self.getFormData();
        for (var field in self.keys) {
            self.extraValues[self.keys[field]] = data[self.keys[field]];
        }
    },
    _setExtraFields: function () {
        var self = this;
        for (var field in self.extraValues) {
            self.renderObjs[0][field].setValue(self.extraValues[field]);
        }
    },
    /**
     * la form data viene riscritta in tutte le fasi, devo reinizializzare i valori interni
     * che altrimenti vanno persi.
     * @private
     */
    _setFormData: function () {
        var self = this;
        self.uploadForm = $(self.config.container).find('form[name="upload_form"]');
        self.dataForm = $(self.config.container).find('form[name="data_form"]');
        self.dataForm.find('input[name="csvProviderName"]').val(self.config.providerName).attr('value', self.config.providerName);
        self.dataForm.find('input[name="fileName"]').val(self.fileName);
        self.dataForm.find('input[name="csv_load_id"]').val(self.loadId).attr('value', self.loadId);
    },
    _initUploadForm: function () {
        var self = this;
        self.uploadForm = $(self.config.container).find('form[name="upload_form"]');
        self.dataForm = $(self.config.container).find('form[name="data_form"]');
        self.dataForm.find('input[name="csvProviderName"]').val(self.config.providerName).attr('value', self.config.providerName);
        self.uploadForm.submit(function (e) {
            e.preventDefault();

            var options = {
                iframe: false,
                //target:        '#'+container,   // target element(s) to be updated with server response
                beforeSubmit: function () {
                    if (self._checkUploadFile()) {
                        self.fileName = null;
                        return true;
                    }
                    return false;
                }, //self.checkFormData,  // pre-submit callback
                success: function (json, textStatus, jqXHR) {
                    $.waitEnd();
                    if (json.error) {
                        $.errorDialog(json.msg);
                        return;
                    }
                    self.fileName = json.result['filename'];
                    self.fileOriginalName = json.result.original_name;
                    self.dataForm.find('input[name="fileName"]').val(json.result['filename']);
                    //$.messageDialog("File caricato con successo");
                    $(self.config.container).find('[data-action="loadcsv"]').prop("disabled", false);
                    self.currentPhase = self.phases[1]; // caricamento
                    self.render();
                    // perche' sto chiamando il render dall'interno di una view dico al controller di connettere le azioni
                    self._controller.connectActions(self.keyId);
                    //$(self.options.container).find('[data-action="savecsv"]').prop("disabled",true);
                }, //self.submitCallBack,  // post-submit callback
                error: function (jqXHR, textStatus, errorThrown) {
                    $.progressDialog().modal("hide");
                    $.errorDialog('error ' + textStatus);
                },
                complete: function () {
                    // STOP LOADING SPINNER
                }
            };
            $(this).ajaxSubmit(options);
            return false;
        });
        self.uploadForm.find('input[type="file"]').change(function () {
            $.waitStart();
            self.uploadForm.submit();
        });
    },
    _checkUploadFile: function () {
        var self = this;
        log.info("beforeLoadSubmit");
        var fileupload = self.uploadForm.find('input[name="file"]').val();
        if (!fileupload) {
            if (self.errors.length > 0) {
                var msg = self.errors.join("<br>");
                $.errorDialog(msg);
            } else
                $.errorDialog("Seleziona il file da caricare");
            return false;
        }
        //var ext = fileupload.match(/\.(.+)$/)[1];
        var extPos = fileupload.lastIndexOf('.');
        var ext = "";
        if (extPos >= 0) {
            ext = fileupload.substr(extPos + 1);
        }
        var cext = ext.toLowerCase();
        switch (cext) {
            case 'xls':
            case 'xlsx':
            case 'csv':
            case 'txt': /* case 'docx': case 'pdf': case 'wps': case 'rtf':  case 'txt': case 'xps': */
                if (self.iszip) {
                    $.waitEnd();
                    $.errorDialog("(" + cext + ") Estensione del file non valida");
                    var control = self.uploadForm.find('input[name="file"]');
                    control.val("");
                    return false;
                }
                break;
            case 'zip':
                if (!self.iszip) {
                    $.waitEnd();
                    $.errorDialog("(" + cext + ") Compressione file non accettata");
                    var control = self.uploadForm.find('input[name="file"]');
                    control.val("");
                    return false;
                }
                break;
            default:
                $.waitEnd();
                $.errorDialog("(" + cext + ") Estensione del file non riconosciuta");
                var control = self.uploadForm.find('input[name="file"]');
                control.val("");
                return false;
        }
        $(self.config.container).find('[data-action="loadcsv"]').prop('disabled', true);
        $(self.config.container).find('[data-action="savecsv"]').prop('disabled', true);

        return true;
    }
});


var ViewCsv = ViewRecord.extend({
    fileName: null,
    fileOriginalName: null,
    loadId: null,
    phases: ['load', 'save'],
    currentPhase: 'load',
    uploadForm: null,
    extraValues: {},   // valori degli extraValues field

    loadPhase: 0,
    savePhase: 1,

    origFieldsType : {},

    init: function (modelName, config, data) {
        this._super(modelName, config, data);
        this.type = 'csv';
        this.renderObjs[0] = {};
        this.defaultRenderType = 'input';
        this.routeType = 'csv';
        this.origFieldsType = this.config.fields_type ? this.config.fields_type : {} ;

    },

    setPhase: function (phase) {
        var self = this;
        self.currentPhase = phase;
        self._getExtraFields();
    },

    goToNextPhase: function () {
        var self = this;
        var phase = self.currentPhase;
        switch (phase) {
            // case 'upload':
            //     return self.setPhase('load');
            case 'load':
                return self.setPhase('save');
            case 'save':
                return self.setPhase('load');

            default:
                //phase = phase + 1;
                return;
        }
    },

    showProgress: function (msg, progress) {
        var self = this;
        var prg = $(self.config.container).find('[data-csvstatus]');
        if (progress === false || progress === undefined) {
            $(prg).find(".progress").css("width", "100%");
            $(prg).find(".progress-bar").text(" ");
        } else {
            $(prg).find(".progress").css("width", progress + "%");
            $(prg).find(".progress-bar").text(progress + "%");
        }
        $(prg).find('[data-csvstatus_msg]').html(msg);
        $(prg).removeClass('hide');
    },
    hideProgress: function () {
        var self = this;
        $(self.config.container).find('[data-csvstatus]').addClass('hide');
    },
    _setKeys: function () {
        var self = this;
        var currentKeys = [];
        console.log("csv load_fields", self.config.load_fields);
        console.log("csv fields", self.config.fields);
        switch (self.currentPhase) {
            case self.phases[self.loadPhase]:
                currentKeys = self.config.load_fields.length > 0 ? self.config.load_fields :
                    ( self.config.fields ? self.config.fields : []);

                if (self.config.load_fields_type && self.config.load_fields_type.length > 0) {
                    self.config.fields_type = self.config.load_fields_type;
                } else {
                    self.config.fields_type = self.origFieldsType;
                }
                break;
            case self.phases[self.savePhase]:

                currentKeys = self.config.save_fields.length > 0 ? self.config.save_fields :
                    ( self.config.fields ? self.config.fields : []);

                if (self.config.save_fields_type && self.config.save_fields_type.length > 0) {
                    self.config.fields_type = self.config.save_fields_type;
                } else {
                    self.config.fields_type = self.origFieldsType;
                }
                break;
        }
        self.keys = currentKeys;
        console.log("fields_type: ", self.config.fields_type);
    },
    setLoadId: function (jobId) {
        var self = this;
        self.loadId = jobId;
        self.dataForm.find('input[name="csv_load_id"]').val(jobId).attr('value', jobId);
    },
    _finalize: function () {
        var self = this;
        self._initUploadForm();
    },

    _renderActions: function () {
        var self = this;
        switch (self.currentPhase) {
            case self.phases[self.loadPhase]:
                // $(self.config.container).find('form[name="upload_form"]').addClass('hide');
                // $(self.config.container).find('[data-filename]').html(self.fileOriginalName);
                self.config.actions = self.config.load_actions;
                break;
            case self.phases[self.savePhase]:
                $(self.config.container).find('form[name="upload_form"]').addClass('hide');
                self.config.actions = self.config.save_actions;
                break;
        }
        console.log("csvview actions", self.config.actions);
        self._super();
        //self._controller.connectActions(self.keyId);
    },

    _render: function () {
        var self = this;
        self._super();
        self._setFormData();
        self._setExtraFields();
    },

    _getExtraFields: function () {
        var self = this;
        var data = self.getFormData();
        for (var field in self.keys) {
            self.extraValues[self.keys[field]] = data[self.keys[field]];
        }
    },
    _setExtraFields: function () {
        var self = this;
        for (var field in self.extraValues) {
            self.renderObjs[0][field].setValue(self.extraValues[field]);
        }
    },
    /**
     * la form data viene riscritta in tutte le fasi, devo reinizializzare i valori interni
     * che altrimenti vanno persi.
     * @private
     */
    _setFormData: function () {
        var self = this;
        self.uploadForm = $(self.config.container).find('form[name="upload_form"]');
        self.dataForm = $(self.config.container).find('form[name="data_form"]');
        self.dataForm.find('input[name="csvProviderName"]').val(self.config.providerName).attr('value', self.config.providerName);
        self.dataForm.find('input[name="fileName"]').val(self.fileName);
        self.dataForm.find('input[name="csv_load_id"]').val(self.loadId).attr('value', self.loadId);
    },
    _initUploadForm: function () {
        var self = this;
        self.uploadForm = $(self.config.container).find('form[name="upload_form"]');
        self.dataForm = $(self.config.container).find('form[name="data_form"]');
        self.dataForm.find('input[name="csvProviderName"]').val(self.config.providerName).attr('value', self.config.providerName);
        self.uploadForm.submit(function (e) {
            e.preventDefault();

            var options = {
                iframe: false,
                //target:        '#'+container,   // target element(s) to be updated with server response
                beforeSubmit: function () {
                    if (self._checkUploadFile()) {
                        self.fileName = null;
                        return true;
                    }
                    return false;
                }, //self.checkFormData,  // pre-submit callback
                success: function (json, textStatus, jqXHR) {
                    $.waitEnd();
                    if (json.error) {
                        $.errorDialog(json.msg);
                        return;
                    }
                    self.fileName = json.result['filename'];
                    self.fileOriginalName = json.result.original_name;
                    self.dataForm.find('input[name="fileName"]').val(json.result['filename']);
                    //$.messageDialog("File caricato con successo");
                    // $(self.config.container).find('[data-action="loadcsv"]').prop("disabled",false);
                    //self.currentPhase = self.phases[1]; // salvataggio
                    // self.render();
                    // perche' sto chiamando il render dall'interno di una view dico al controller di connettere le azioni
                    // self._controller.connectActions(self.keyId);
                    //$(self.options.container).find('[data-action="savecsv"]').prop("disabled",true);
                }, //self.submitCallBack,  // post-submit callback
                error: function (jqXHR, textStatus, errorThrown) {
                    $.progressDialog().modal("hide");
                    $.errorDialog('error ' + textStatus);
                },
                complete: function () {
                    // STOP LOADING SPINNER
                }
            };
            $(this).ajaxSubmit(options);
            return false;
        });
        self.uploadForm.find('input[type="file"]').change(function () {
            $.waitStart();
            self.uploadForm.submit();
        });
    },
    _checkUploadFile: function () {
        var self = this;
        log.info("beforeLoadSubmit");
        var fileupload = self.uploadForm.find('input[name="file"]').val();
        if (!fileupload) {
            if (self.errors.length > 0) {
                var msg = self.errors.join("<br>");
                $.errorDialog(msg);
            } else
                $.errorDialog("Seleziona il file da caricare");
            return false;
        }
        //var ext = fileupload.match(/\.(.+)$/)[1];
        var extPos = fileupload.lastIndexOf('.');
        var ext = "";
        if (extPos >= 0) {
            ext = fileupload.substr(extPos + 1);
        }
        var cext = ext.toLowerCase();
        switch (cext) {
            case 'xls':
            case 'xlsx':
            case 'csv':
            case 'txt': /* case 'docx': case 'pdf': case 'wps': case 'rtf':  case 'txt': case 'xps': */
                if (self.iszip) {
                    $.waitEnd();
                    $.errorDialog("(" + cext + ") Estensione del file non valida");
                    var control = self.uploadForm.find('input[name="file"]');
                    control.val("");
                    return false;
                }
                break;
            case 'zip':
                if (!self.iszip) {
                    $.waitEnd();
                    $.errorDialog("(" + cext + ") Compressione file non accettata");
                    var control = self.uploadForm.find('input[name="file"]');
                    control.val("");
                    return false;
                }
                break;
            default:
                $.waitEnd();
                $.errorDialog("(" + cext + ") Estensione del file non riconosciuta");
                var control = self.uploadForm.find('input[name="file"]');
                control.val("");
                return false;
        }
        $(self.config.container).find('[data-action="loadcsv"]').prop('disabled', true);
        $(self.config.container).find('[data-action="savecsv"]').prop('disabled', true);

        return true;
    }
});

var ViewCsvG2 = ViewCsv.extend({

    _setKeys: function () {
        var self = this;

        var groups = {};

        console.log('LOADFIELDS:' , self.config.load_fields_type);
        console.log('SAVEFIELDS:' , self.config.save_fields_type);
        console.log('FIELDS:' , self.config.fields_type);
        console.log('ORIGFIELDS:' , self.origFieldsType);

            switch (self.currentPhase) {
                case self.phases[self.loadPhase]:
                    groups = self.config.load_groups ? self.config.load_groups :
                        ( self.config.groups ? self.config.groups : {});

                    console.log("load fields_type length: ", self.config.load_fields_type.length);
                    if (self.config.load_fields_type) {
                        self.config.fields_type = self.config.load_fields_type;
                    } else {
                        self.config.fields_type = self.origFieldsType;
                    }
                    break;
                case self.phases[self.savePhase]:

                    groups = self.config.save_groups ? self.config.save_groups :
                        ( self.config.groups ? self.config.groups : {});
                    if (self.config.save_fields_type) {
                        self.config.fields_type = self.config.save_fields_type;
                    } else {
                        self.config.fields_type = self.origFieldsType;
                    }

                    break;
            }

        console.log("fields_type: ", self.config.fields_type);
        if  (Object.keys(groups).length > 0)
        {
            self.keys = [];
            for (var g in groups) {
                for (var f in groups[g].fields) {
                    self.keys.push(groups[g].fields[f]);
                }
            }

            console.log('KEYSSSS: ',self.keys);
            return;
        }

        // self.super();
    },

    _renderElement: function (key) {
        var self = this;

        // caso speciale per gli hidden che non hanno struttura html
        var type = self.config.fields_type[key] ? self.config.fields_type[key].type : 'input';
        if (type == 'input' && self.config.fields_type[key] && self.config.fields_type[key].inputType=="hidden") {
            console.log('CSV HIDDENT');
            var container = $.createDynamicContainer();
            var r = self._createRender(container, key);
            r.render();
            self.jQe.find('[data-hidden_fields]').append(container.html());
            r.container = self.jQe.find('[data-hidden_fields]');
            container.remove();
            return;
        }
        var structure = self._getDefaultStructure(key); //self.config.labels?self.config.labels:'left';
        var container = $.createDynamicContainer('#' + self.prefixTemplateClass + '_' + structure + '_view_edit_tpl');
        var safeKey = key.replace(/[\])}\[{(]/g, '');
        $(container.first().children()[0]).addClass('view-field-'+safeKey);
        container.find('.' + type + '-field').addClass('field-' + safeKey + ' ' + self.modelName + '-field-' + safeKey);
        self._translateItem(container, safeKey);
        if (self.langs.length > 1) {
            var imgLang = self._langField(self.config, key);
            self._renderImgLang(container, imgLang);
        }
        container.find('[data-field_value]').attr('data-field_value', key);
        //console.log(container.html());
        var group = self._getGroup(key);
        self.jQe.find('[data-view_elements="' + self.modelName + '"]').find('[data-group="' + group + '"]').append(container.html());
        //self.jQe.find('[data-view_elements="' + self.modelName + '"]').append(container.html());
        container.remove();
        var realContainer = self.jQe.find('[data-view_elements="' + self.modelName + '"]').find('[data-field_value="' + key + '"]');


        var r = self._createRender(realContainer, key);
        r.render();
    },
    _getGroup: function (key) {
        var self = this;
        var group = 'g0';

        var groups = {};
        switch (self.currentPhase) {
            case self.phases[self.loadPhase]:
                groups = self.config.load_groups ? self.config.load_groups :
                    ( self.config.groups ? self.config.groups : {});
                break;
            case self.phases[self.savePhase]:

                groups = self.config.save_groups ? self.config.save_groups :
                    ( self.config.groups ? self.config.groups : {});
                break;
        }

        for (var g in groups) {
            if ($.inArray(key, groups[g].fields) >= 0)
                return g;
        }
        return group;
    }

});


var ViewCsvData = ViewList.extend({
    init: function (modelName, data, config) {
        this._super(modelName, data, config);
        this.type = 'list';
        this.defaultRenderType = 'text';
        this.routeType = 'datacsv';
    },
    _renderHeaderActions: function (jQrow) {
        var self = this;

        if (!self.data.has_errors) {
            self.config.actions = _.difference(self.config.actions, ['actionCsvShowAll', 'actionCsvShowError']);
        }
        self._super(jQrow);
    },

    _finalizeRow: function (index) {
        var self = this;
        self._super(index);


        // aggiungo il tastino error    
        var errorKeys = {};
        for (var i in self.data.value[index].errors) {
            var k = self.data.value[index].errors[i].field_name;
            if (!errorKeys[k]) {
                errorKeys[k] = [];
            }
            errorKeys[k].push(self.data.value[index].errors[i]);
        }
        //console.log("keyssss",errorKeys);
        for (var key in self.data.value[index]) {

            if (errorKeys[key]) {
                var errorData = {
                    value: self.data.value[index][key],
                    errors: errorKeys[key]
                };
                var container = self.renderObjs[index][key].container;
                var tpl = $.getTemplate('#error_tpl', {});
                $(container).append(tpl);
                self._renderError(key, errorData, container, index);


            }
        }
    },
    _renderError: function (key, errorData, container, index) {
        var self = this;

        $(container).find('[data-error]').data('error', errorData);
        if (self.config.error_type[key] && self.config.error_type[key].readonly) {
            $(container).find('[data-bt_error]').addClass('hide');
            var errorHtml = '';
            for (var i in errorData.errors) {
                errorHtml += $.translate('validation-' + Utility.lowerCase(errorData.errors[i].error_name)) + '<br/>';
            }
            $(container).find('[data-error_text]').html(errorHtml);
            return;
        }
//console.log("ERROR TYPE",self.config.error_type);

        $(container).find('[data-bt_error]').click(function () {
            var errorData = $(this).data('error');
            var policy = 'text';
            if (self.config.error_type[key] && self.config.error_type[key].fix_policy)
                policy = self.config.error_type[key].fix_policy.type;

            switch (policy) {
                case 'text':
                    self._createTextFix(errorData);
                    break;
                case 'select':
                    errorData.domainValues = self.config.error_type[key].fix_policy.domainValues ?
                        self.config.error_type[key].fix_policy.domainValues : {};
                    errorData.domainValuesOrder = self.config.error_type[key].fix_policy.domainValuesOrder ?
                        self.config.error_type[key].fix_policy.domainValuesOrder : [];
                    self._createSelectFix(errorData);
                    break;
                case 'autocomplete':
                    break;
                case 'insert':
                    break;
                default:
                    if ($.isFunction(self.config[policy+'Fix'])) {
                        self.config[policy + 'Fix'].apply(self,[errorData, index]);
                    } else {
                        throw "policy " + policy + "not yet implemented";
                    }
                    return;
            }


        });
    },


    // _renderError: function (key, errorData, container, index) {
    //     var self = this;
    //
    //     $(container).find('[data-error]').data('error', errorData);
    //     if (self.config.error_type[key] && self.config.error_type[key].readonly) {
    //         $(container).find('[data-bt_error]').addClass('hide');
    //         $(container).find('[data-error_text]').html($.translate('validation-' + Utility.lowerCase(errorData.errors[0].error_name)))
    //         return;
    //     }
    //     //console.log("ERROR TYPE",self.config.error_type);
    //
    //     $(container).find('[data-bt_error]').click(function () {
    //         var errorData = $(this).data('error');
    //         var policy = 'text';
    //         if (self.config.error_type[key] && self.config.error_type[key].fix_policy)
    //             policy = self.config.error_type[key].fix_policy.type;
    //
    //         switch (policy) {
    //             case 'text':
    //                 self._createTextFix(errorData);
    //                 break;
    //             case 'select':
    //                 errorData.domainValues = self.config.error_type[key].fix_policy.domainValues ?
    //                     self.config.error_type[key].fix_policy.domainValues : {};
    //                 errorData.domainValuesOrder = self.config.error_type[key].fix_policy.domainValuesOrder ?
    //                     self.config.error_type[key].fix_policy.domainValuesOrder : [];
    //                 self._createSelectFix(errorData);
    //                 break;
    //             case 'autocomplete':
    //                 break;
    //             case 'insert':
    //                 break;
    //             default:
    //                 if ($.isFunction(self.config[policy+'Fix'])) {
    //                     self.config[policy + 'Fix'].apply(self,[errorData, index]);
    //                 } else {
    //                     throw "policy " + policy + "not yet implemented";
    //                 }
    //                 return;
    //         }
    //
    //
    //     });
    // },

    _createTextFix: function (errorData) {
        var self = this;
        var _controller = self._controller;
        var model = self.modelName;
        // creo la form degli errori con il primo errore che trovo.
        errorData.errorForm = self._createFormErrorData(errorData.errors[0]);
        errorData.errors[0].error_label = $.translate('validation-' + Utility.lowerCase(errorData.errors[0].error_name));
        console.log('errorData', errorData, model);
        var tplError = $.getTemplate('#error_dialogcontent_tpl', errorData);
        $.generalDialog(tplError, {
            btok_label: 'Salva',
            btcancel_label: 'Annulla',
            title: 'Correggi errore'
        }).ok(function () {
            var data = $('#generalDialog').find('form').serializeAssoc();
            data[data.field_name] = data.value;
            data.id = data.csv_table_id;
            _controller.fixCsvError(model, data, function (json) {
                if (json.error) {
                    $.errorDialog(json.msg);
                    return;
                }
                _controller.reload(self.keyId);
            });
        });
    },

    _createSelectFix: function (errorData) {
        var self = this;
        var _controller = self._controller;
        var model = self.modelName;
        // creo la form degli errori con il primo errore che trovo.
        errorData.errorForm = self._createFormErrorData(errorData.errors[0]);
        errorData.errors[0].error_label = $.translate('validation-' + Utility.lowerCase(errorData.errors[0].error_name));
        console.log('errorData', errorData, model);
        var tplError = $.getTemplate('#error_dialogcontent_select_tpl', errorData);
        $.generalDialog(tplError, {
            btok_label: 'Salva',
            btcancel_label: 'Annulla',
            title: 'Correggi errore'
        }).ok(function () {
            var data = $('#generalDialog').find('form').serializeAssoc();
            data[data.field_name] = data.value;
            data.id = data.csv_table_id;
            _controller.fixCsvError(model, data, function (json) {
                if (json.error) {
                    $.errorDialog(json.msg);
                    return;
                }
                _controller.reload(self.keyId);
            });
        });
    },

    _createFormErrorData: function (error) {
        var errorForm = [];
        for (var k in error) {
            if (k != 'value')
                errorForm.push({key: k, value: error[k]});
        }
        return errorForm;
    }

});